import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { Store } from "@ngrx/store";
import { GetEmployeeAction } from "../../employees/employees.actions";
import { AvatarUploaderModalData } from "./avatar-uploader-modal.interface";

@Component({
  selector: "app-avatar-uploader-modal",
  templateUrl: "./avatar-uploader-modal.component.html",
  styleUrls: ["./avatar-uploader-modal.component.scss"],
  standalone: false,
})
export class AvatarUploaderModalComponent {
  avatarUploadUrl: string;
  thumbnailPhotoUrl: string;
  localAvatar: boolean;
  employeeId: string;

  constructor(
    public dialogRef: MatDialogRef<AvatarUploaderModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AvatarUploaderModalData,
    private store: Store,
  ) {
    this.avatarUploadUrl = data.avatarUploadUrl;
    this.thumbnailPhotoUrl = data.thumbnailPhotoUrl;
    this.localAvatar = data.localAvatar;
    this.employeeId = data.employeeId;
  }

  onAvatarSaved(): void {
    if (this.employeeId) {
      this.store.dispatch(new GetEmployeeAction(this.employeeId));
    }
    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }
}
